import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// standard merge function
export function cn(...inputs: Parameters<typeof clsx>) {
  return twMerge(clsx(...inputs));
}
